import { produce } from 'immer';
import { entity } from 'simpler-state';

import { FxResponseType } from '../services/subscription/types';

const INITIAL_STATE: Record<string, FxResponseType> = {};

const self = entity(INITIAL_STATE);

const setSubscriptionPrices = (symbol: string, value: FxResponseType): void => {
  self.set(
    produce(state => {
      state[symbol] = value;
    }),
  );
};

export default {
  use: () => self.use(data => data),
  get: () => self.get(),
  useCustom: (symbol: string) => self.use()[symbol],
  getCustom: (symbol: string) => self.get()[symbol],
  setSubscriptionPrices,
};
